import { defineMessages } from "react-intl";

export const cardMenuMessages = defineMessages({
  cardMenuItemLoading: {
    id: "B2LE7A",
    defaultMessage: "working...",
    description: "menu item loading",
  },
});
